import { useAtmQuery } from "@/domains/bank/hooks/useAtmQuery";
import { useBankCharacterQuery } from "@/domains/bank/hooks/useBankCharacterQuery";
import { useShowBankATM } from "@/domains/bank/hooks/useShowBankATM";
import { BankATMModal } from "@/domains/bank/components/BankATMModal";

export function BankATMContainer() {
  const { isOpen, close, atmId } = useShowBankATM();
  const { data: bankCharacter, isLoading } = useBankCharacterQuery({ enabled: isOpen });
  const atmQuery = useAtmQuery(atmId);

  if (!isOpen) return null;

  return (
    <div>
      <BankATMModal
        open={isOpen}
        onClose={close}
        atmId={atmId}
        bankCharacter={bankCharacter}
        hasAccount={bankCharacter?.hasBankAccount}
        isLoading={isLoading || atmQuery.isLoading}
      />
    </div>
  );
}
